export default class FetchIvrs {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.ivrs.setLoading();
    this.context.gateways.ivr.fetchAll();
    this.context.gateways.ivr.subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/ivr/fetch_ivrs.js